// EspaceBenevoles.js
// Page principale de l'espace bénévoles (admin)
// Nécessite npm install axios date-fns

import React, { useState, useEffect } from 'react';
import '../../styles/EspaceBenevoles.css';
import PlanningFlex from '../../components/PlanningFlex';
import ReserveSuperAdmin from './ReserveSuperAdmin';
import ImpPlanning from './ImpPlanning';
import imgImage from '../../images/2.jpg';

function AdminPage({ token, droit }) {
  return (
    <div style={{ padding: '20px' }}>
      <ReserveSuperAdmin token={token} droit={droit} />
    </div>
  );
}


function EspaceBenevoles({ benevoleState, onBenevoleStateChange }) {
  const { token, droit, currentView } = benevoleState;
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  const handleLogin = async (e) => {
    e.preventDefault();
    const { nom_utilisateur, mot_de_passe } = e.target.elements;
    try {
      const response = await fetch(`${API_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nom_utilisateur: nom_utilisateur.value,
          mot_de_passe: mot_de_passe.value,
        }),
      });
      
      if (!response.ok) {
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      
      if (!data.token) {
        throw new Error('Pas de token reçu du serveur');
      }
      
      const newState = {
        token: data.token,
        droit: data.droit,
        currentView: 'planning'
      };
      onBenevoleStateChange(newState);
      localStorage.setItem('token', data.token);
    } catch (error) {
      console.error('Erreur de connexion:', error);
      alert('Échec de la connexion. Vérifiez votre nom utilisateur et mot de passe. Si l\'erreur persiste, contactez le bureau de la Gare de Trôo');
    }
  };

  const handleLogout = () => {
    onBenevoleStateChange({
      token: '',
      droit: '',
      currentView: 'planning'
    });
    localStorage.removeItem('token');
  };

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken && !token) {
      try {
        const decodedToken = JSON.parse(atob(storedToken.split('.')[1]));
        // Vérifier l'expiration du token (exp est en secondes) avant de restaurer la session
        if (!decodedToken.exp || decodedToken.exp * 1000 < Date.now()) {
          localStorage.removeItem('token');
          return;
        }
        onBenevoleStateChange({
          token: storedToken,
          droit: decodedToken.droit,
          currentView: 'planning'
        });
      } catch (error) {
        console.error("Erreur lors du décodage du token :", error);
        localStorage.removeItem('token');
      }
    }
  }, []);

  return (
    <div className="espace-benevoles-container">
      {!token ? (
        <div className="login-page-benevoles">
          <div className="login-left-benevoles">
            <img src={imgImage} alt="Gare de Trôo" className="login-image-benevoles" />
          </div>
          <div className="login-right-benevoles">
            <div className="login-content-benevoles">
              <h1 className="welcome-title-benevoles">Espace<br/>Bénévoles</h1>
              <p className="welcome-text-benevoles">
                Bienvenue sur la gestion du planning.
                Veuillez vous connecter pour accéder à votre espace.
              </p>
              <form onSubmit={handleLogin} className="login-form-benevoles">
              <h2 className="login-title-benevoles">Se connecter</h2>
              
              <div className="login-field-benevoles">
                <label htmlFor="nom_utilisateur">Nom d'utilisateur</label>
                <input
                  id="nom_utilisateur"
                  name="nom_utilisateur"
                  type="text"
                  required
                  className="login-input-benevoles"
                />
              </div>
              
              <div className="login-field-benevoles">
                <label htmlFor="mot_de_passe">Mot de passe</label>
                <div className="password-container-benevoles">
                  <input
                    id="mot_de_passe"
                    name="mot_de_passe"
                    type={showPassword ? "text" : "password"}
                    required
                    className="login-input-benevoles"
                  />
                  <button
                    type="button"
                    className="password-toggle-benevoles"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  >
                    {showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>
              
              <div className="login-remember-benevoles">
                <input
                  type="checkbox"
                  id="remember"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label htmlFor="remember">Se souvenir de moi</label>
              </div>
              
              <button type="submit" className="login-button-benevoles">
                Se connecter
              </button>
            </form>
            </div>
          </div>
        </div>
      ) : currentView === 'admin' ? (
        <AdminPage
          token={token}
          droit={droit}
        />
      ) : (
        <div>
          <PlanningFlex token={token} droit={droit} />
        </div>
      )}
    </div>
  );
}

export default EspaceBenevoles;
